export const COURSE_FINANCE_TYPE = {
  EXPENSE: 1,
  INCOME: 2,
} as const;

export const COURSE_FINANCE_OPTIONS = [
  { value: COURSE_FINANCE_TYPE.EXPENSE, label: "Koszt" },
  { value: COURSE_FINANCE_TYPE.INCOME, label: "Przychód" },
];
